export interface stateForm {
    username: string,
    IDcard: string,
    nation: string,
    sex: string,
    birth: string,
    Culture: string,
    family: string,
    phone: string,
    wxnumber: string,
    location: string,
    rural: string,
    detailLocation: string,
    zhNumber: string,
    khh: string,
    bankNumber: string,
    addressId: addressId,
}
export interface addressId {
    village: string,
    street: string,
    villageStrName: string,
    streetStrName: string,
    provinceId: number,
    cityId: number,
    areaId: number,
    provinceStrName: string,
    cityStrName: string,
    areaStrName: string,
    streetid: string
}

export interface stateType {
    id: number,
    minDate: any,
    maxDate: any,
    nationList: Array<string>,
    showPicker: boolean,
    showSex: boolean,
    showCulture: boolean,
    showNation: boolean,
    showLocation: boolean,
    showRural: boolean,
    showRural2: boolean,
    areaAllList: Array<any>
    headImg: Array<any>,
    fieldNames: object,
    ruralList: Array<any>,
    ruralList2: Array<any>
    areaCode: string,
    defaultEducationIndex:number,
    selectInitDate:any,
    defaultSexIndex: number,
    defaultNationIndex:number,
    defaultStreet1Index:number,
    defaultStreet2Index:number,
    router:any,
    avatar:string,
    lat:number,
    lng:number,
    showMap:boolean
    route:any
}
interface headType {
    url?:string,
    status?:string,
    message?:string
}

export const educationList = [{ id: 1, text: '文盲', index: 0 }, { idcardChange: 2, text: '小学', index: 1 }, { id: 3, text: '初中', index: 2 }, { id: 4, text: '中专', index: 3 }, { id: 5, text: '高中', index: 4 }, { id: 6, text: '大专及以上', index: 5 }]